import { useState, useEffect } from "react";
import { getData, addData, updateData } from "../utils/localCrud";
import "./Settings.css";

export default function Settings() {
    const [settings, setSettings] = useState({});
    const [siteName, setSiteName] = useState("");
    const [adminEmail, setAdminEmail] = useState("");

    useEffect(() => {
        const data = getData("settings")[0] || {};
        setSettings(data);
        setSiteName(data.siteName || "");
        setAdminEmail(data.adminEmail || "");
    }, []);

    const handleSave = () => {
        const newSettings = { id: 1, siteName, adminEmail };
        if (getData("settings").length === 0) {
            addData("settings", newSettings);
        } else {
            updateData("settings", newSettings);
        }
        setSettings(newSettings);
        alert("Settings Saved");
    };

    return (
        <div className="settings">
            <h2>Settings</h2>
            <div className="form">
                <label>Site Name</label>
                <input
                    type="text"
                    value={siteName}
                    onChange={(e) => setSiteName(e.target.value)}
                />

                <label>Admin Email</label>
                <input
                    type="email"
                    value={adminEmail}
                    onChange={(e) => setAdminEmail(e.target.value)}
                />

                <button onClick={handleSave}>Save Settings</button>
            </div>

            <div className="current-settings">
                <h3>Current Settings</h3>
                <p><strong>Site Name:</strong> {settings.siteName}</p>
                <p><strong>Admin Email:</strong> {settings.adminEmail}</p>
            </div>
        </div>
    );
}
